import { Box, ITheme, useTheme } from '@mui/material';
import React, { useEffect } from 'react';
import GlobalStatisticsItem from './GlobalStatisticsItem';
import {ReactComponent as gainsIcon} from '../../assets/gains.svg';
import {ReactComponent as progressIcon} from '../../assets/progress.svg';
import {ReactComponent as givemoneyIcon} from '../../assets/givemoney.svg';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../store/reducers/store';
import { loadStatistics } from '../../store/actions/dashboard';
import { Utilities } from '../../utility/utils';

const GlobalStatistics: React.FC = () =>{
    const { t } = useTranslation();
    const statistics = useAppSelector(state => state.dashboard.globalStatistics);
    const dispatch = useAppDispatch();
    const theme = useTheme() as ITheme;

    useEffect(() => {
        if (statistics === undefined){
            dispatch(loadStatistics());
        }
    }, [dispatch, statistics])

    if (statistics === undefined){
        return <></>
    }

    return <Box display={"flex"} gap={"23px"}>
        <GlobalStatisticsItem title={t('DashboardGlobalStatsTotalFunds')} symbol={gainsIcon} value={`${statistics.nbFunds.value}`} change={statistics.nbFunds.change} color={theme.palette.leo.color19}/>
        <GlobalStatisticsItem title={t('DashboardGlobalStatsTotalOpenPortfolios')} symbol={progressIcon} value={`${statistics.nbOpenedPortfolios.value}`} proportion={statistics.nbOpenedPortfolios.proportion} change={statistics.nbOpenedPortfolios.change}  color={theme.palette.leo.color17} />
        <GlobalStatisticsItem title={t('DashboardGlobalStatsTotalClosedPortfolios')} symbol={givemoneyIcon} value={`€${Utilities.toFriendlyMoneyValue(statistics.nbClosedPortfolios.value)}`} proportion={statistics.nbClosedPortfolios.proportion} change={statistics.nbClosedPortfolios.change}  color={theme.palette.leo.color8} />
    </Box>;
}

export default GlobalStatistics;